export default __webpack_public_path__ + "static/media/service4.bd796731.jpg";